import React from 'react'
import { getImageUrl } from 'lib/image/imageUtils'
import WrappedLottieAnimation from '../../WrappedLottieAnimation'
import styled, { keyframes } from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import zIndex from 'styles/tools/z-index'

const FadedWorldMap = styled(WrappedLottieAnimation)`
  opacity: 0.15;
  width: 100%;
  height: 100%;
`

const float = keyframes`
  0%, 100% {
    transform: translate(-50%, -50%);
  }
  50% {
    transform: translate(-50%, calc(-50% - 10px));
  }
`

const WorldMapContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
`

const SearchTheWorld = styled.div`
  z-index: ${zIndex.offerFilters};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30vw;
  height: 30vw;
  min-width: ${rem(100)};
  min-height: ${rem(100)};
  max-width: ${rem(200)};
  max-height: ${rem(200)};
  animation: ${float} 3s ease-in-out infinite;
  /* GPU acceleration for smooth animation */
  will-change: transform;
  backface-visibility: hidden;

  ${mediaQueryUp.tablet} {
    width: 20vw;
    height: 20vw;
    min-width: ${rem(120)};
    min-height: ${rem(120)};
  }

  ${mediaQueryUp.desktop} {
    width: 15vw;
    height: 15vw;
    min-width: ${rem(140)};
    min-height: ${rem(140)};
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    will-change: auto;
  }
`

const SearchImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

function WorldMapAnimation() {
  const searchImageUrl = getImageUrl('wrapped-magnifying-glass-2', {
    format: 'png',
    width: 400,
  })

  return (
    <WorldMapContainer>
      <SearchTheWorld>
        <SearchImage src={searchImageUrl} alt="Search" />
      </SearchTheWorld>
      <FadedWorldMap animationName="world_map" />
    </WorldMapContainer>
  )
}

export default WorldMapAnimation
